const editInfo = [{
	key: 'Year',
	title: '年度'
}, {
	key: 'InvClassName',
	title: '产品线'
}, {
	key: 'ObjTypeName',
	title: '经销商类型'
}, {
	key: 'CusName',
	title: '经销商名称'
}, {
	key: 'LEVEL1_5',
	title: 'LEVEL1.5'
}, {
	key: 'MarkupRate',
	title: '加价率'
}]

const editForm = [
	[{
			key: 'JanQuota',
			modelValue: undefined,
			title: "一月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 66,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'FebQuota',
			modelValue: undefined,
			title: "二月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'MarQuota',
			modelValue: undefined,
			title: "三月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		}
	],
	[{
			key: 'AprQuota',
			modelValue: undefined,
			title: "四月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'MayQuota',
			modelValue: undefined,
			title: "五月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'JunQuota',
			modelValue: undefined,
			title: "六月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		}
	],
	[{
			key: 'JulQuota',
			modelValue: undefined,
			title: "七月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'AugQuota',
			modelValue: undefined,
			title: "八月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'SepQuota',
			modelValue: undefined,
			title: "九月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		}
	],
	[{
			key: 'OctQuota',
			modelValue: undefined,
			title: "十月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'NovQuota',
			modelValue: undefined,
			title: "十一月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		},
		{
			key: 'DecQuota',
			modelValue: undefined,
			title: "十二月指标：",
			inputtype: "NumberInput",
			inputflag: true,
			fontSize: 14,
			color: "#333333",
			lableheight: 20,
			X: false,
			types: "text",
			placeholder: "请输入",
			width: 210,
			height: 32,
			disabled: false,
			marginLeft: 46,
			marginTop: 20,
			displayVal: "inline-block",
			fontWeightVal: 500,
			max: undefined,
			min: 0
		}
	]
]
export {
	editInfo,
	editForm
};